import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import {
  Table,
  Row,
  Col
} from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import { normalSort } from "../Utility/sort";
import { ChartScreen, SearchAndDownload, TimeControl } from "../components";
import * as XLSX from "xlsx";
import { stringYMDHMS3 } from "../Utility/dateTime";
import { colors, paymentNameMaps } from "../configs";
import { handleDigit, searchFilterFunction } from "../Utility/function";

const { backgroundColor, white } = colors;


function ReportByPayment() {
    const { selectedBill, startDate, endDate } = useSelector((state)=> state.bill);
      const [search, setSearch] = useState('');

      const { masterDisplay, totalSale, billQty } = useMemo(()=>{
        let newProduct = []
        let totalSale = 0;
        const billQty = selectedBill.length
        let masterPayment = selectedBill.flatMap(a=>a.payment)
        if(search){
          masterPayment = searchFilterFunction(masterPayment,search,'name')
        } 
        masterPayment.forEach(item=>{
          const { amount, change = 0, id, name } = item;
          let findProduct = newProduct.find(a=>a.id === id)
          if(findProduct){
            findProduct.qty ++
            findProduct.amount += amount - change
          } else {
            if(name){
              newProduct.push({
                id, name, qty:1, amount:amount - change
              })
            } else {
              newProduct.push({
                id, 
                name:paymentNameMaps[id], 
                qty:1, 
                amount:amount - change
              })
            }
            
          }
          totalSale += amount - change
        })
    
        return {
          masterDisplay:normalSort('amount',newProduct.map(item=>{
            const { amount, ...rest } = item;
            return {
              ...rest,
              amount:handleDigit(amount),
              ratioAmount:totalSale>0?handleDigit(amount*100/totalSale):0,
              ยอดขาย:parseFloat(amount.toFixed(2))
            }
          })),
          totalSale:handleDigit(totalSale),
          billQty
        }
      },[selectedBill, search]);


      const exportToXlsx = () => {
        // Define the headers
        const headers = [
          ["No.", "รายการ", "จำนวนบิล", "ยอดชำระ", "ยอดชำระต่อทั้งหมด"]
        ];
      
        // Map the data from the table
        const data = masterDisplay.map((item, index) => [
          index + 1,
          item.name,
          item.qty,
          item.amount,
          item.ratioAmount,
        ]);
      
        // Add the total row with "รวม" spanning two columns
        data.push([
          "รวม", "", // These will be merged
          billQty,
          totalSale,
          "100.00"
        ]);
      
        // Create the worksheet and workbook
        const worksheet = XLSX.utils.aoa_to_sheet([...headers, ...data]);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "ยอดขายตามช่องทางชำระเงิน");
      
        // Merge "รวม" over two columns (A12:B12 if it's row 12)
        worksheet["!merges"] = [
          { s: { r: data.length, c: 0 }, e: { r: data.length, c: 1 } } // Merge first two cells of last row
        ];
      
        // Trigger file download
        XLSX.writeFile(workbook, `ยอดขายตามช่องทางชำระเงิน ${stringYMDHMS3(startDate)} - ${stringYMDHMS3(endDate)}.xlsx`);
      };

  return (
    <div  style={styles.container}  >
      <div style={{position:'sticky', top:0, backgroundColor, zIndex:9 }} >
        <h1>ยอดขายตามช่องทางชำระเงิน</h1>
        <TimeControl  />
        <SearchAndDownload
            {...{
              placeholder:'ค้นหาด้วยชื่อ',
              search,
              setSearch,
              exportToXlsx
            }}
        />
      </div>
      <Row   style={{ backgroundColor:white,borderRadius:20,marginLeft:0,marginRight:0,marginBottom:20 }} >
          <Col  lg={12} >
            <div style={{ backgroundColor:white,margin:5,padding:10,borderRadius:20,height:'400px',marginRight:0,overflowX:'auto' }} >
                <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center' }} >
                  <h4>ยอดขายรวม: <b>{totalSale}</b> บาท</h4>
                </div>
                <ChartScreen chart={masterDisplay} bar={'ยอดขาย'} name={''} content={'ยอดขาย'} />
            </div>
          </Col>
      </Row>
      <Table striped bordered hover responsive  variant="light"   >
            <thead  >
            <tr>
                <th style={styles.container3}>No.</th>
                <th style={styles.container4}>รายการ</th>
                <th style={styles.container4}>จำนวนบิล</th>
                <th style={styles.container4}>ยอดชำระ</th>
                <th style={styles.container4}>ยอดชำระต่อทั้งหมด(%)</th>
            </tr>
            </thead>
            <tbody  >
            {masterDisplay.map((item, index) => {
                const { id, name, amount, ratioAmount, qty } = item;
                return <tr  style={styles.container5} key={id} >
                            <td style={styles.container6}>{index+1}.</td>
                            <td >{name}</td>
                            <td style={styles.container6}>{qty}</td>
                            <td style={styles.container6}>{amount}</td>
                            <td style={styles.container6}>{ratioAmount}</td>
                        </tr>
            })}
            <tr>
              <td colSpan={2} style={styles.container6} >รวม</td>
              <td style={styles.container6} >{billQty}</td>
              <td style={styles.container6} >{totalSale}</td>
              <td style={styles.container6} >100.00</td>
            </tr>
            </tbody>
        </Table>
    </div>
  );
}

const styles = {
  container : {
      height:'100vh',
      scrollY:'auto'
  },
  container2 : {
      display:'flex',justifyContent:'flex-end',marginBottom:'1rem'
  },
  container3 : {
      width: '5%', textAlign:'center'
  },
  container4 : {
      width: '15%', textAlign:'center', minWidth:'120px'
  },
  container5 : {
      cursor: 'pointer'
  },
  container6 : {
      textAlign:'center'
  }
};

export default ReportByPayment;